import type { Tuition as TuitionData } from '@mathflat/domain/Tuition'
import { orderBy } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

import ExtendedMap from '@/models/ExtendedMap'

import type { Month } from '../common/Calendar/Month'
import Tuition from './Tuition'

export class TuitionByMonthly {
  month: Month
  private tuitionMap = new ExtendedMap<Tuition['id'], Tuition>()

  constructor(month: Month, data?: TuitionData[] | Tuition[]) {
    makeAutoObservable(this)

    this.month = month
    if (data) {
      const tuitionList =
        data[0] instanceof Tuition ? (data as Tuition[]) : data.map((value) => new Tuition(value))

      this.tuitionMap = ExtendedMap.fromArr(tuitionList, 'id')
    }
  }

  get lastTuition() {
    if (this.size > 0) {
      return this.toOrderedArr[this.size - 1]
    }
  }

  get toArr() {
    return this.tuitionMap.toArr
  }

  get toOrderedArr() {
    return orderBy(this.tuitionMap.toArr, (tuition) => new Date(tuition.paymentDate))
  }

  get dateKey() {
    return this.month.toString
  }

  get size() {
    return this.tuitionMap.size
  }

  get(key: Tuition['id']) {
    return this.tuitionMap.get(key)
  }

  set(key: Tuition['id'], tuition: Tuition) {
    this.tuitionMap.set(key, tuition)
  }

  delete(key: Tuition['id']) {
    this.tuitionMap.delete(key)
  }
}
